import type { SelectOption } from '@/components/common/OptionSelect';
import type { LeaveType } from '@/features/leaveTypes/types/leaveType.types';
import {
  KEEP_PRESENT_REQUEST_OPTION_ID,
  LEAVE_REQUEST_TYPE_LABELS,
  REVIEW_DECISION,
} from '../constants/leaveApplication.constants';
import type {
  ReviewDecision,
  ReviewLeaveApplicationFormValues,
  ReviewLeaveApplicationPayload,
} from '../types/leaveApplication.types';

const KEEP_PRESENT_REQUEST_OPTION: SelectOption = {
  id: KEEP_PRESENT_REQUEST_OPTION_ID,
  name: LEAVE_REQUEST_TYPE_LABELS.ATTENDANCE_CLAIM,
};

export function getApproveAsOptions(leaveTypes: LeaveType[] | undefined): SelectOption[] {
  const leaveTypeOptions = (leaveTypes ?? [])
    .filter((leaveType) => leaveType.isActive)
    .map((leaveType) => ({ id: leaveType.id, name: leaveType.name }));
  return [KEEP_PRESENT_REQUEST_OPTION, ...leaveTypeOptions];
}

export function getApproveAsName(
  options: readonly SelectOption[],
  approveAs: number | undefined,
): string | undefined {
  return options.find((option) => option.id === approveAs)?.name;
}

export function toReviewPayload(
  decision: ReviewDecision,
  { comment, approveAs }: ReviewLeaveApplicationFormValues,
): ReviewLeaveApplicationPayload {
  const isApprovedAsLeave =
    decision === REVIEW_DECISION.APPROVE &&
    approveAs !== undefined &&
    approveAs !== KEEP_PRESENT_REQUEST_OPTION_ID;
  if (!isApprovedAsLeave) return { comment };
  return { comment, requestType: 'LEAVE_APPLICATION', leaveTypeId: approveAs };
}
